// Module
var code = "<a href=\"{OPEN_RECORD}\" target=\"_blank\" rel=\"noopener\">Click here to open the record</a>";
// Exports
export default code;